import React from 'react';

import PropTypes from 'prop-types';

import {
    Avatar,
    Grid,
    GridItem,
    List,
    ListAdornment,
    ListBody,
    ListItem,
    PinIcon,
    Typography,
} from 'wanderu-components';

import styles from './InTheArea.scss';

const propTypes = {
    places: PropTypes.arrayOf(PropTypes.shape({
        stat: PropTypes.shape({
            mi: PropTypes.number,
        }),
        text: PropTypes.string,
    })),
    title: PropTypes.string,
};

const defaultProps = {
    places: [],
    title: '',
};

function InTheArea({ places = [], title }) {
    if (!places.length) {
        return null;
    }

    return (
        <>
            <Typography
                className={styles.headerNearby}
                component="h2"
                id="nearby-header-section"
                variant="h3"
            >
                {title}
            </Typography>
            <Grid
                columnSpacing={6}
                columns={2}
                component={List}
                rowSpacing={0}
            >
                {places.map(({ text, stat }) => (
                    <GridItem
                        component={ListItem}
                        key={text}
                        sm={1}
                        xs={2}
                    >
                        <ListAdornment aria-hidden>
                            <Avatar variant="square">
                                <PinIcon />
                            </Avatar>
                        </ListAdornment>
                        <ListBody component={Typography}>
                            {text}
                        </ListBody>
                        <ListAdornment
                            component={Typography}
                        >
                            {stat.mi} mi
                        </ListAdornment>
                    </GridItem>
                ))}
            </Grid>
        </>
    );
}

InTheArea.propTypes = propTypes;
InTheArea.defaultProps = defaultProps;

export default InTheArea;
